export const DATA_TEST_IDS = {
  MODAL: 'media_preview_modal',
  IMAGE: 'media_preview_image',
  CLOSE: 'media_preview_close',
};
